// extracted by mini-css-extract-plugin
export default {"panel":"panel--zpV7P"};